export default [
  {
    year: 2015,
    url: 'https://yuschick.github.io/31-Nights-of-Horror-2015/',
  },
  {
    year: 2016,
    url: 'https://yuschick.github.io/31-Nights-of-Horror-2016/',
  },
  {
    year: 2017,
    url: 'https://yuschick.github.io/31-Nights-of-Horror-2017/',
  },
  {
    year: 2018,
    url: 'https://yuschick.github.io/31-Nights-of-Horror-2018/',
  },
];



// WEBPACK FOOTER //
// ./src/data/nav.js